export enum SiteState {
    Normal = 1,
    Maintenance = 2,
    NotStarted = 4,
    Ended = 8,
}
